export const USER_MENU_PROFILE_ITEM = 'USER_MENU_PROFILE_ITEM';
export const USER_MENU_SETTINGS_ITEM = 'USER_MENU_SETTINGS_ITEM';
export const USER_MENU_LOGOUT_ITEM = 'USER_MENU_LOGOUT_ITEM';
